var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "deposit detail" },
    [
      _vm.lang == _vm.$config.LANG_KOR
        ? [
            _c("div", { staticClass: "scroll" }, [
              _c("article", { staticClass: "content-header bg-type" }, [
                _vm._m(0),
                _vm._m(1),
                true
                  ? _c("div", { staticClass: "summary" }, [
                      _vm._m(2),
                      _vm._m(3)
                    ])
                  : _vm._e()
              ]),
              _vm._m(4)
            ])
          ]
        : _vm.lang == _vm.$config.LANG_ENG
        ? [
            _c("div", { staticClass: "scroll" }, [
              _c("article", { staticClass: "content-header bg-type" }, [
                _vm._m(5),
                _vm._m(6),
                true
                  ? _c("div", { staticClass: "summary" }, [
                      _vm._m(7),
                      _vm._m(8)
                    ])
                  : _vm._e()
              ]),
              _vm._m(9)
            ])
          ]
        : [
            _c("div", { staticClass: "scroll" }, [
              _c("article", { staticClass: "content-header bg-type" }, [
                _vm._m(10),
                _vm._m(11),
                true
                  ? _c("div", { staticClass: "summary" }, [_vm._m(12)])
                  : _vm._e()
              ]),
              _vm._m(13)
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [_c("h2", [_vm._v("정기적금")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "description" }, [
      _c("p", [
        _vm._v(" 매월 일정한 금액을 저축하여 목돈을 마련하는 적립식 상품 ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "tit" }, [
        _c("span", { staticClass: "exchange-unit" }, [_vm._v("MMK")])
      ]),
      _c("div", { staticClass: "percent" }, [_vm._v(" 6.5-7.5% ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "tit" }, [
        _c("span", { staticClass: "exchange-unit" }, [_vm._v("USD")])
      ]),
      _c("div", { staticClass: "percent" }, [_vm._v(" 0.1-0.2% ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", { staticClass: "contents" }, [
      _c("dl", { staticClass: "dlist dlist-item--type5" }, [
        _c("dt", [_vm._v("상품개요")]),
        _c("dd", [
          _vm._v("매월 일정한 금액을 저축하여 목돈을 마련하는 적립식 상품")
        ]),
        _c("dt", [_vm._v("가입대상")]),
        _c("dd", [_vm._v("미얀마 국민, 외국인거주자")]),
        _c("dt", [_vm._v("신규가능통화")]),
        _c("dd", [_vm._v("MMK , USD")]),
        _c("dt", [_vm._v("계좌개설 최소금액")]),
        _c("dd", [_vm._v("MMK 50,000"), _c("br"), _vm._v("USD 50")]),
        _c("dt", [_vm._v("최소유지금액")]),
        _c("dd", [_vm._v("N/A")]),
        _c("dt", [_vm._v("수수료금액")]),
        _c("dd", [_vm._v("Chargeless")]),
        _c("dt", [_vm._v("가입방법")]),
        _c("dd", [_vm._v("영업점가입")])
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("Required documents for application")])
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("Individual")]),
        _c("p", [
          _vm._v(
            "(1) National Registration Card (or) Passport (Visa should be valid)"
          )
        ]),
        _c("p", [_vm._v("(2) Source of Fund (For USD currency)")])
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("Company")]),
        _c("p", [_vm._v("(1) Company Extract from DICA")]),
        _c("p", [_vm._v("(2) Company Registration from DICA")]),
        _c("p", [_vm._v("(3) MIC Permit (if relevant)")]),
        _c("p", [
          _vm._v("(4) Board of Director Resolution (or) Power of Attorney")
        ]),
        _c("p", [
          _vm._v(
            "(5) Cover Letter with Company Letter Head for applying bank account(s)"
          )
        ]),
        _c("p", [
          _vm._v(
            "(6) Copy of NRCs (or) Copy of Passports (valid Business visa for each signatory) of director and Authorize signatory lists"
          )
        ]),
        _c("p", [_vm._v("(7) Shareholder lists")]),
        _c("p", [_vm._v("(8) Partnership Agreement (if relevant)")])
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("Branch/ Representative Office")]),
        _c("p", [_vm._v("(1) Company Registration from DICA")]),
        _c("p", [_vm._v("(2) Company Extract from DICA")]),
        _c("p", [_vm._v("(3) Parent Registration Certificate (if relevant)")]),
        _c("p", [
          _vm._v(
            "(4) Power of Attorney (or) Consent and Certificate of Director"
          )
        ]),
        _c("p", [
          _vm._v(
            "(5) Copy of NRCs (or) Copy of Passports (valid visa for each signatory) of director lists"
          )
        ]),
        _c("p", [
          _vm._v(
            "(6) Cover Letter with Company Letter Head for applying bank account(s)"
          )
        ]),
        _c("p", [_vm._v("(7) Shareholder lists")])
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("Local NGO/ International NGO")]),
        _c("p", [_vm._v("(1) Organization Registration Certificate")]),
        _c("p", [_vm._v("(2) Constitution of NGO")]),
        _c("p", [
          _vm._v(
            "(3) Brief of each committee members (Name and Address of senior management and identification documents)"
          )
        ]),
        _c("p", [
          _vm._v("(4) Committee meeting minutes regarding opening of accounts")
        ]),
        _c("p", [
          _vm._v(
            "(5) Authorized persons’ National Registration Card or Passport (valid visa) for each signatory) of organization persons"
          )
        ])
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [
          _vm._v(
            "Association, charities, club/ societies and religious organizations"
          )
        ]),
        _c("p", [
          _vm._v("(1) Certificate of registration relative Government")
        ]),
        _c("p", [_vm._v("(2) Constitution of entity")]),
        _c("p", [
          _vm._v("(3) Committee meeting minutes regarding opening of accounts")
        ]),
        _c("p", [
          _vm._v(
            "(4) Authorized persons’ National Registration Card or Passport (valid business visa for each signatory) of organization persons"
          )
        ]),
        _c("p", [
          _vm._v(
            "(5) Cover Letter with Company Letter Head for applying bank account(s)"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h2", [_vm._v("Installment Deposit")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "description" }, [
      _c("p", [
        _vm._v(
          " This Installment deposit mainly focus to the customers with regular incomes to deposit a fixed amount every month into their account and earn a higher rate of interest than a regular savings account "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "tit" }, [
        _c("span", { staticClass: "exchange-unit" }, [_vm._v("MMK")])
      ]),
      _c("div", { staticClass: "percent" }, [_vm._v(" 6.5-7.5% ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "tit" }, [
        _c("span", { staticClass: "exchange-unit" }, [_vm._v("USD")])
      ]),
      _c("div", { staticClass: "percent" }, [_vm._v(" 0.1-0.2% ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", { staticClass: "contents" }, [
      _c("dl", { staticClass: "dlist dlist-item--type5" }, [
        _c("dt", [_vm._v("About the products")]),
        _c("dd", [
          _vm._v(
            "This Installment deposit mainly focus to the customers with regular incomes to deposit a fixed amount every month into their account and earn a higher rate of interest than a regular savings account"
          )
        ]),
        _c("dt", [_vm._v("Eligibilty")]),
        _c("dd", [_vm._v("Myanmar National and Resident Foreigner")]),
        _c("dt", [_vm._v("Available currency")]),
        _c("dd", [_vm._v("MMK , USD")]),
        _c("dt", [_vm._v("Initial Amount")]),
        _c("dd", [_vm._v("MMK 50,000"), _c("br"), _vm._v("USD 50")]),
        _c("dt", [_vm._v("Minimum Amount")]),
        _c("dd", [_vm._v("N/A")]),
        _c("dt", [_vm._v("Fees")]),
        _c("dd", [_vm._v("Chargeless")]),
        _c("dt", [_vm._v("How to apply")]),
        _c("dd", [_vm._v("Visit KB branch")])
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("Required documents for application")])
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("Individual")]),
        _c("p", [
          _vm._v(
            "(1) National Registration Card (or) Passport (Visa should be valid)"
          )
        ]),
        _c("p", [_vm._v("(2) Source of Fund (For USD currency)")])
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("Company")]),
        _c("p", [_vm._v("(1) Company Extract from DICA")]),
        _c("p", [_vm._v("(2) Company Registration from DICA")]),
        _c("p", [_vm._v("(3) MIC Permit (if relevant)")]),
        _c("p", [
          _vm._v("(4) Board of Director Resolution (or) Power of Attorney")
        ]),
        _c("p", [
          _vm._v(
            "(5) Cover Letter with Company Letter Head for applying bank account(s)"
          )
        ]),
        _c("p", [
          _vm._v(
            "(6) Copy of NRCs (or) Copy of Passports (valid Business visa for each signatory) of director and Authorize signatory lists"
          )
        ]),
        _c("p", [_vm._v("(7) Shareholder lists")]),
        _c("p", [_vm._v("(8) Partnership Agreement (if relevant)")])
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("Branch/ Representative Office")]),
        _c("p", [_vm._v("(1) Company Registration from DICA")]),
        _c("p", [_vm._v("(2) Company Extract from DICA")]),
        _c("p", [_vm._v("(3) Parent Registration Certificate (if relevant)")]),
        _c("p", [
          _vm._v(
            "(4) Power of Attorney (or) Consent and Certificate of Director"
          )
        ]),
        _c("p", [
          _vm._v(
            "(5) Copy of NRCs (or) Copy of Passports (valid visa for each signatory) of director lists"
          )
        ]),
        _c("p", [
          _vm._v(
            "(6) Cover Letter with Company Letter Head for applying bank account(s)"
          )
        ]),
        _c("p", [_vm._v("(7) Shareholder lists")])
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("Local NGO/ International NGO")]),
        _c("p", [_vm._v("(1) Organization Registration Certificate")]),
        _c("p", [_vm._v("(2) Constitution of NGO")]),
        _c("p", [
          _vm._v(
            "(3) Brief of each committee members (Name and Address of senior management and identification documents)"
          )
        ]),
        _c("p", [
          _vm._v("(4) Committee meeting minutes regarding opening of accounts")
        ]),
        _c("p", [
          _vm._v(
            "(5) Authorized persons’ National Registration Card or Passport (valid visa) for each signatory) of organization persons"
          )
        ])
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [
          _vm._v(
            "Association, charities, club/ societies and religious organizations"
          )
        ]),
        _c("p", [
          _vm._v("(1) Certificate of registration relative Government")
        ]),
        _c("p", [_vm._v("(2) Constitution of entity")]),
        _c("p", [
          _vm._v("(3) Committee meeting minutes regarding opening of accounts")
        ]),
        _c("p", [
          _vm._v(
            "(4) Authorized persons’ National Registration Card or Passport (valid business visa for each signatory) of organization persons"
          )
        ]),
        _c("p", [
          _vm._v(
            "(5) Cover Letter with Company Letter Head for applying bank account(s)"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h2", [_vm._v("အရစ်ကျအပ်ငွေစာရင်း")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "description" }, [
      _c("p", [
        _vm._v(
          " အရစ်ကျအပ်ငွေစာရင်းဆိုသည်မှာ လစဉ်ပုံမှန်သတ်မှတ်ထားသော ငွေပမာဏအား သတ်မှတ်ထားသော ကာလအတွင်း ငွေစုဆောင်းခြင်းဖြစ်သည်။ ပုံမှန်အပ်ငွေစာရင်းထက် အတိုးနှုန်းမြင့်ပါသည်။ "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item item-row" }, [
      _c("div", { staticClass: "tit" }, [
        _c("span", { staticClass: "exchange-unit" }, [
          _vm._v(
            "တစ်နှစ်လျှင် ၆.၅ ရာခိုင်နှုန်း မှ ၇.၅ ရာခိုင်နှုန်း (မြန်မာကျပ်)"
          ),
          _c("br"),
          _vm._v("၀.၁- ၀.၂ ရာခိုင်နှုန်း (နိုင်ငံခြားငွေ ဒေါ်လာ)")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", { staticClass: "contents" }, [
      _c("dl", { staticClass: "dlist dlist-item--type5" }, [
        _c("dt", [_vm._v("ထုတ်ကုန်အကြောင်း")]),
        _c("dd", [
          _vm._v(
            "အရစ်ကျအပ်ငွေစာရင်းဆိုသည်မှာ လစဉ်ပုံမှန်သတ်မှတ်ထားသော ငွေပမာဏအား သတ်မှတ်ထားသော ကာလအတွင်း ငွေစုဆောင်းခြင်းဖြစ်သည်။ ပုံမှန်အပ်ငွေစာရင်းထက် အတိုးနှုန်းမြင့်ပါသည်။"
          )
        ]),
        _c("dt", [_vm._v("အရည်အချင်းကိုက်ညီမှု")]),
        _c("dd", [
          _vm._v(
            "မြန်မာနိုင်ငံသားနှင့် မြန်မာနိုင်ငံအတွင်းနေထိုင်သူနိုင်ငံခြားသာ"
          )
        ]),
        _c("dt", [_vm._v("ငွေကြေးအမျိုးအစား")]),
        _c("dd", [_vm._v("မြန်မာကျပ်၊ ဒေါ်လာ")]),
        _c("dt", [_vm._v("ကနဉီးအပ်ငွေ")]),
        _c("dd", [_vm._v("ကျပ် ၅၀,၀၀၀ ၊ ဒေါ်လာ ၅၀")]),
        _c("dt", [_vm._v("အနည်းဆုံးပမာဏ")]),
        _c("dd", [_vm._v("မရှိပါ")]),
        _c("dt", [_vm._v("အခကြေးငွေ")]),
        _c("dd", [_vm._v("မရှိပါ")]),
        _c("dt", [_vm._v("လျှောက်ထားနည်း")]),
        _c("dd", [_vm._v("ဘဏ်ခွဲမှာလျှောက်ထားပါ")])
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("လျှောက်လွှာများအတွက်လိုအပ်သောစာရွက်စာတမ်းများ")])
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("တစ်ဦးချင်း")]),
        _c("p", [
          _vm._v(
            "(1) မှတ်ပုံတင် (သို့မဟုတ်) နိုင်ငံကူးလက်မှတ် (သက်တမ်းရှိဗီဇာ)"
          )
        ]),
        _c("p", [
          _vm._v("(2) ဝင်ငွေရရှိမှုအထောက်အထား (USD currency စာရင်းဖွင့်လျှင်)")
        ])
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("ကုမ္ပဏီ")]),
        _c("p", [_vm._v("(1) DICA မှ Company Extract")]),
        _c("p", [_vm._v("(2) DICA မှ ကုမ္ပဏီမှတ်ပုံတင်လက်မှတ်")]),
        _c("p", [_vm._v("(3) MIC Permit (if relevant)")]),
        _c("p", [
          _vm._v(
            "(4) ဒါရိုက်တာအဖွဲ့၏ဆုံးဖြတ်မှုအစည်းအဝေးမှတ်တမ်း (သို့မဟုတ်) ကိုယ်စားလှယ်လွှဲစာ"
          )
        ]),
        _c("p", [
          _vm._v(
            "(5) ဘဏ်စာရင်း(များ)ဖွင့်ရန်တင်ပြထားသော ကုမ္ပဏီ Letter Head ပါစာ"
          )
        ]),
        _c("p", [
          _vm._v(
            "(6) ဒါရိုက်တာနှင့် ဘဏ်စာရင်းလက်မှတ်ထိုးခွင့်ရှိသူများ၏ မှတ်ပုံတင် (သို့မဟုတ်) နိုင်ငံကူးလက်မှတ် မိတ္တူ (လက်မှတ်တစ်ခုချင်းစီအတွက် သက်တမ်းရှိ လုပ်ငန်းဗီဇာ)"
          )
        ]),
        _c("p", [_vm._v("(7) ရှယ်ယာရှင်စာရင်း")]),
        _c("p", [_vm._v("(8) မိတ်ဖက်သဘောတူညီချက် (လိုအပ်လျှင်)")])
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("ဘဏ်ခွဲ/ ကိုယ်စားလှယ်ရုံး")]),
        _c("p", [_vm._v("(1) DICA မှ Company Extract")]),
        _c("p", [_vm._v("(2) DICA မှ ကုမ္ပဏီမှတ်ပုံတင်လက်မှတ်")]),
        _c("p", [_vm._v("(3) ရုံးချူပ်မှတ်ပုံတင်လက်မှတ် (လိုအပ်လျှင်)")]),
        _c("p", [
          _vm._v(
            "(4) ကိုယ်စားလှယ်လွှဲစာ (သို့မဟုတ်) ဒါရိုက်တာသဘောတူညီချက်လက်မှတ်"
          )
        ]),
        _c("p", [
          _vm._v(
            "(5) စာရင်းရှိ ဒါရိုက်တာများ၏ မှတ်ပုံတင် (သို့မဟုတ်) နိုင်ငံကူးလက်မှတ် မိတ္တူ (လက်မှတ်တစ်ခုချင်းစီအတွက် သက်တမ်းရှိ လုပ်ငန်းဗီဇာ)"
          )
        ]),
        _c("p", [
          _vm._v(
            "(6) ဘဏ်စာရင်း(များ)ဖွင့်ရန်တင်ပြထားသော ကုမ္ပဏီ Letter Head ပါစာ"
          )
        ]),
        _c("p", [_vm._v("(7) ရှယ်ယာရှင်စာရင်း")])
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("ပြည်တွင်း NGO/ နိုင်ငံတကာ NGO")]),
        _c("p", [_vm._v("(1) အဖွဲ့အစည်းမှတ်ပုံတင်လက်မှတ်")]),
        _c("p", [_vm._v("(2) NGO သင်းဖွဲ့စည်းမျဥ်း")]),
        _c("p", [
          _vm._v(
            "(3) အသင်းဝင်တစ်ဦးချင်းစီ၏ကိုယ်ရေးအကျဥ်း (Senior Management များ၏ အမည်၊ လိပ်စာနှင့် မှတ်ပုံတင်စာရွက်စာတမ်းများ)"
          )
        ]),
        _c("p", [
          _vm._v(
            "(4) အဖွဲ့အစည်း၏ ဘဏ်စာရင်းများဖွင့်ရန်ဆုံးဖြတ်မှုအစည်းအဝေးမှတ်တမ်း"
          )
        ]),
        _c("p", [
          _vm._v(
            "(5) အဖွဲ့အစည်းဘဏ်စာရင်းလက်မှတ်ထိုးခွင့်ရှိသူများ၏ မှတ်ပုံတင် (သို့မဟုတ်) နိုင်ငံကူးလက်မှတ် မိတ္တူ (လက်မှတ်တစ်ခုချင်းစီအတွက် သက်တမ်းရှိ လုပ်ငန်းဗီဇာ)"
          )
        ])
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("လူမှုကူညီရေးနှင့် ဘာသာ‌ရေးအသင်းအဖွဲ့များ")]),
        _c("p", [_vm._v("(1) သက်ဆိုင်ရာဝန်ကြီးဌာနမှတ်ပုံတင်လက်မှတ်")]),
        _c("p", [_vm._v("(2) သင်းဖွဲ့စည်းမျဥ်း")]),
        _c("p", [
          _vm._v(
            "(3) အဖွဲ့အစည်း၏ ဘဏ်စာရင်းများဖွင့်ရန်ဆုံးဖြတ်မှုအစည်းအဝေးမှတ်တမ်း"
          )
        ]),
        _c("p", [
          _vm._v(
            "(4) အဖွဲ့အစည်းဘဏ်စာရင်းလက်မှတ်ထိုးခွင့်ရှိသူများ၏ မှတ်ပုံတင် (သို့မဟုတ်) နိုင်ငံကူးလက်မှတ် မိတ္တူ (လက်မှတ်တစ်ခုချင်းစီအတွက် သက်တမ်းရှိ လုပ်ငန်းဗီဇာ)"
          )
        ]),
        _c("p", [
          _vm._v(
            "(5) ဘဏ်စာရင်း(များ)ဖွင့်ရန်တင်ပြထားသော ကုမ္ပဏီ Letter Head ပါစာ"
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }